import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2abf949c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "np-panel" }
const _hoisted_2 = { class: "np-panel-phone-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "np-panel__phone-logo" }, null, -1))
const _hoisted_4 = { class: "np-panel__phones phones" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "np-panel__logo",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.logoUrl})` })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phones, (phone) => {
          return (_openBlock(), _createElementBlock("li", {
            key: phone,
            class: "phones__item"
          }, [
            _createElementVNode("a", {
              href: `tel:${phone}`
            }, _toDisplayString(phone), 9, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ]))
}